import { render, staticRenderFns } from "./NewsDetailsNine.vue?vue&type=template&id=e4a3f1a0"
import script from "./NewsDetailsNine.vue?vue&type=script&lang=js"
export * from "./NewsDetailsNine.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsNine.vue?vue&type=style&index=0&id=e4a3f1a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports